/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Back_ContactInputs */

const fr_welcome_back_contact = /** @type {(inputs: Welcome_Back_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour toute interrogation autre, contactez-moi par e-mail`)
};

const en_welcome_back_contact = /** @type {(inputs: Welcome_Back_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For any other question, contact me by email`)
};

/**
* | output |
* | --- |
* | "For any other question, contact me by email" |
*
* @param {Welcome_Back_ContactInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const welcome_back_contact = /** @type {((inputs?: Welcome_Back_ContactInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Back_ContactInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_welcome_back_contact(inputs)
	return en_welcome_back_contact(inputs)
});